import {FormDialogComponent} from "../shared/dialog/form-dialog/form-dialog.component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Component, Inject} from "@angular/core";
import {DialogComponentData} from "../shared/dialog/interfaces";
import {DialogService} from "../shared/dialog/dialog.service";
import {FormGroupManager} from "../shared/cml-forms/form-factory.service";
import {DialogComunicationService} from "../shared/dialog/dialog-comunication.service";
import {ValidationService} from "../shared/cml-forms/validation.service";
import {Observable, of, Subscription} from "rxjs";
import {UcetniObdobiDto} from "../ucetni-obdobi-data/models/UcetniObdobiDtos";


@Component({
    selector: 'cml-dokladova-rada-form-service',
    templateUrl: '../shared/dialog/form-dialog/form-dialog.component.html',
    styleUrls: ['../shared/dialog/form-dialog/form-dialog.component.scss'],
    standalone: false
})
export class DokladovaRadaFormDialogService extends FormDialogComponent
{

  public override subscription: Subscription = new Subscription();
  override filteredOptions: Observable<UcetniObdobiDto[]> = new Observable<UcetniObdobiDto[]>();
  constructor(dialogService: DialogService,
              dialogRef: MatDialogRef<DokladovaRadaFormDialogService>,
              formManager: FormGroupManager,
              dialogComunicationService: DialogComunicationService,
              validationService: ValidationService,
              @Inject(MAT_DIALOG_DATA) public override data: DialogComponentData)
  {
    super(dialogRef,data , dialogService, formManager, dialogComunicationService, validationService);

    this.subscription = dialogComunicationService.UOresults$.subscribe(
      result => {
        result.then((res:any) => {
          this.options = res;
          this.filteredOptions = of(this.options);
        })
      });
  }

  override async ngOnInit(): Promise<void> {

    await super.ngOnInit();
      this.form.controls["kodUo"].valueChanges.subscribe(x => {
        this.filteredOptions = of(this._filter(x));
      });

  }
  private _filter(value: UcetniObdobiDto): UcetniObdobiDto[] {
    return this.options.filter((option:any) => option["kod"].includes(value));
  }
}
